module.exports = __webpack_public_path__ + "media/images/icons/tab-rounded-corner-left-63da91cf8b641dadd93cb32a0ec584b9.svg";